import { render, staticRenderFns } from "./DataTableSubcolBuilder.vue?vue&type=template&id=f1d253a0&"
import script from "./DataTableSubcolBuilder.vue?vue&type=script&lang=js&"
export * from "./DataTableSubcolBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports